import { attendanceSessionConstants } from "../../constants/attendanceSession.constants";
import { attendanceStudentRecordConstants } from "../../constants/attendanceStudentRecord.constants";
import { attendanceSessionService } from "../../services/attendanceSession.service";
import { attendanceStudentRecordService } from "../../services/attendanceStudentRecord.service";
import { notificationActions } from "./notification.actions";

// attendanceActions.ts
interface AttendanceSessionAttributes {
    id: number;
    classId: number;
    date: Date;
    createdByTeacherId: number;
    lastUpdatedByTeacherId: number;
    note?: string;
    createdAt?: Date;
    updatedAt?: Date;
  }
  
  const getAttendanceStudentRecordByMonth = (year: any, month: any) => {
    return async (dispatch: any) => {
      const request = () => ({ type: attendanceStudentRecordConstants.GET_BY_MONTH_REQUEST });
      const success = (attendanceStudentRecords: any) => ({ type: attendanceStudentRecordConstants.GET_BY_MONTH_SUCCESS, payload: attendanceStudentRecords });
      const failure = (error: any) => ({ type: attendanceStudentRecordConstants.GET_BY_MONTH_FAILURE, payload: error });
  
      try {
        const attendanceStudentRecords = await attendanceStudentRecordService.getByMonth(year, month);
        dispatch(success(attendanceStudentRecords));
      } catch (error: any) {
        console.log(error)
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification('dòng 30' + error.toString(), 'DANGER'));
      }
    };
  };

  const getAttendanceStudentRecordBySessionId = (sessionId: number) => {
    return async (dispatch: any) => {
      const request = () => ({ type: attendanceStudentRecordConstants.GET_BY_SESSION_REQUEST });
      const success = (attendanceStudentRecords: any) => ({ type: attendanceStudentRecordConstants.GET_BY_SESSION_SUCCESS, payload: attendanceStudentRecords });
      const failure = (error: any) => ({ type: attendanceStudentRecordConstants.GET_BY_SESSION_FAILURE, payload: error });
  
      dispatch(request());
      try {
        const attendanceStudentRecords = await attendanceStudentRecordService.getBySessionId(sessionId);
        dispatch(success(attendanceStudentRecords));
        return attendanceStudentRecords; // Return để có thể dùng trực tiếp
      } catch (error: any) {
        console.log(error)
        dispatch(failure(error.toString()));
        dispatch(notificationActions.addNotification('Lỗi lấy dữ liệu điểm danh: ' + error.toString(), 'DANGER'));
        return [];
      }
    };
  };

const getAttendanceStudentRecordByMonthsAndStudent = (months: string[], studentId: number) => {   // months dạng ["2025-08","2025-09","2025-10"]
  return async (dispatch: any) => {
    const request = () => ({
      type: attendanceStudentRecordConstants.GET_BY_MONTHS_AND_STUDENT_REQUEST,
    });
    const success = (attendanceStudentRecords: any) => ({
      type: attendanceStudentRecordConstants.GET_BY_MONTHS_AND_STUDENT_SUCCESS,
      payload: attendanceStudentRecords,
    });
    const failure = (error: any) => ({
      type: attendanceStudentRecordConstants.GET_BY_MONTHS_AND_STUDENT_FAILURE,
      payload: error,
    });

    dispatch(request());

    try {
      // Gọi hàm trong service (xem phần dưới)
      const attendanceStudentRecords = await attendanceStudentRecordService.getByMonthsAndStudent(months, studentId);

      dispatch(success(attendanceStudentRecords));
    } catch (error: any) {
      console.error(error);
      dispatch(failure(error.toString()));
      dispatch(notificationActions.addNotification('Lỗi lấy dữ liệu điểm danh: ' + error.toString(), 'DANGER'));
    }
  };
};



export const attendanceStudentRecordActions = {
    getAttendanceStudentRecordByMonth,
    getAttendanceStudentRecordBySessionId,
    getAttendanceStudentRecordByMonthsAndStudent,
};